// extracted by mini-css-extract-plugin
export default {"container":"hVEvr1","text":"bhlgkg","block":"ez8ytS"};